<template>
  <div id="meeting-form-signatures" v-if="meeting">
    <k-modal :show="showModal" @close="closeSignaturesModal" class="view-signatures-modal">
      <template #header>
        <h3>{{ meeting.meeting_name }}
          <k-label v-if="meeting?.support_function" :label="startCase(meeting.support_function)"></k-label>
        </h3>
      </template>
      <template #body>
        <div class="view-signatures-modal-body">
          <div class="signature-list">
            <p class="signature-title">Signatures</p>
            <div class="profile-cards">
              <user-profile-card
                v-for="signature in signatures"
                :key="signature.signee_name"
                :name="signature.signee_name"
                :role="signature.signee_role"
              >
                <signature-date
                  :date="signature.signature_date"
                  :is-optional="signature.isOptional"
                  :manual-completion-note="signature.manualCompletionNote"
                ></signature-date>
              </user-profile-card>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <button class="modal-return-button btn btn-default cancel-btn" @click="closeSignaturesModal">Close</button>
      </template>
    </k-modal>
  </div>
</template>

<style scoped>
.signature-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.signature-list li {
  display: grid;
  grid-template-columns: 250px 100px 100px;
  column-gap: 2rem;
  padding: 0.5rem 0;
}

.signature-list li span {
  text-align: left;
}
</style>

<script>
import TextFormattingMixin from '@mixins/text-formatting-mixins';
import KModal from '@base-components/k-modal.vue';
import UserProfileCard from '@base-components/user-profile-card.vue';
import KLabel from '@base-components/k-label.vue';
import SignatureDate from './signature-date.vue';

export default {
  mixins: [TextFormattingMixin],

  components: {
    SignatureDate,
    UserProfileCard,
    KModal,
    KLabel,
  },

  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    meeting: {
      type: Object,
    },
  },

  computed: {
    signatures() {
      const learnerSignature = this.meeting?.signatures?.find(signature => signature.signee_role === 'learner');
      const meetingOwnerSignature = this.meeting?.signatures?.find(signature => signature.signee_role !== 'learner');

      return [
        learnerSignature || {
          signee_name: this.meeting?.student_name,
          signee_role: 'learner',
          signature_date: this.meeting?.completed_on,
          isOptional: !this.requiresLearnerSignature,
          manualCompletionNote: this.meeting?.manual_completion_note,
        },
        meetingOwnerSignature || {
          signee_name: this.meetingOwnerName,
          signee_role: 'meeting_owner',
          signature_date: null,
          isOptional: false,
        },
      ];
    },

    requiresLearnerSignature() {
      return this.meeting?.requires_learner_signature ?? true;
    },

    meetingOwnerName() {
      if (this.meeting?.meeting_owner_name) {
        return this.meeting.meeting_owner_name;
      }
      if (this.meeting?.coach_name && this.meeting?.support_function === 'coach') {
        return this.meeting.coach_name;
      }
      if (this.meeting?.data_mentor_name && this.meeting?.support_function === 'data_mentor') {
        return this.meeting.data_mentor_name;
      }
      return 'Meeting Owner';
    },
  },

  methods: {
    closeSignaturesModal() {
      this.$emit('close');
    },
  },
};
</script>
